export const SuggestedTitle = ({ children }: { children: string }): React.ReactElement => {
  return <h2 className="text-3xl lg:text-4xl font-evogria text-ivory !mb-3 uppercase">{children}</h2>
}
